module.exports = __webpack_public_path__ + "static/img/fac_porwer.2bf549af.png";